import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import API from '@/services/api'
import Permissions from '@/utilities/Permissions'
import Datetime from 'vue-datetime'
import VueLazyLoad from 'vue-lazyload'
import '@/utilities/sockets.js'

//import '@/utilities/serviceWorker'

import '@/assets/styles/app.scss'
import 'vue-datetime/dist/vue-datetime.css'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

window.axios = require('axios')
window.axios.defaults.headers.common = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}

Vue.config.productionTip = false

Vue.use(Permissions)
Vue.use(Datetime)
Vue.use(VueLazyLoad)

API.init()

//screen.orientation.lock('landscape');

Vue.filter('formatLimitedBy', function (value) {
    let formatted = ''

    value = value.toLowerCase()

    switch (value) {
        case 'niet van toepassing':
            formatted = 'Niet van toepassing'
            break
        case 'niet toegankelijk':
            formatted = 'Opname beperkt vanwege ontoegankelijkheid.'
            break
        case 'geen lichtbron / met zaklamp':
            formatted = 'Opname beperkt door afwezigheid lichtbron / opname met zaklamp.'
            break
        case 'zicht onttrokken':
            formatted = 'Opname beperkt wegens deels aan zicht onttrokken. '
            break
        case 'in verbouwing':
            formatted = 'Beperkte opname wegens object in verbouwing.'
            break
        case 'sneeuw':
            formatted = 'Opname beperkt vanwege sneeuw.'
            break
        case 'begroeiing':
            formatted = 'Opname beperkt door begroeiing. '
            break
        case 'afgesloten':
            formatted = 'Geen opname mogelijk wegens afgesloten ruimte(n). '
            break
        case 'geen duidelijk zichtbare gebreken':
            formatted = 'Geen duidelijk zichtbare gebreken'
            break
        case 'verder geen zichtbare gebreken':
            formatted = 'Verder geen zichtbare gebreken'
            break
        case 'geen bijzonderheden':
            formatted = 'Geen bijzonderheden '
            break
        case 'opslag goederen':
            formatted = 'Opname beperkt door opslag goederen.'
            break
        case 'niemand aanwezig':
            formatted = 'Geen/beperkte opname wegens afwezigheid bewoner(s)/gebruiker(s).'
            break
        case 'geen medewerking interieur / wel exterieur':
            formatted = 'Beperkte opname wegens geen toestemming bewoner(s)/gebruiker(s) interieuropname.'
            break
        case 'geen medewerking interieur en exterieur':
            formatted = 'Geen opname wegens geen toestemming bewoner(s)/gebruiker(s).'
            break
        case 'gesloten':
            formatted = 'Opname bewerkt wegens (af)gesloten. '
            break
        case 'leegstaand':
            formatted = 'Opname bewerkt wegens leegstand.'
            break
        case 'deurbel / intercom defect':
            formatted = 'Geen opname mogelijk wegens defecte deurbel/intercom.'
            break
        case 'geen tijd voor opname':
            formatted = 'Geen opname mogelijk wegens geen tijd bewoner(s)/gebruiker(s).'
            break
        case 'taalbarriere':
            formatted = 'Geen opname mogelijk wegens taalbarriere.'
            break
        case 'in steigers':
            formatted = 'Beperkte opname wegens object in steigers.'
            break
        case 'afwezig ondanks afspraak':
            formatted = 'Geen/beperkte opname wegens afwezigheid bewoner(s)/gebruiker(s) ondanks gemaakte afspraak.'
            break
        default:
            formatted = 'Beperkt door ' + value.toLowerCase()
            break
    }

    return formatted
})

// Dutch number formatting: 1.234 and 12,5
Vue.filter('formatNumber', function (value, decimals = 0) {
    let number = Number(value)

    if (value === null || value === '' || isNaN(number)) {
        return value
    }

    return number.toLocaleString('nl-NL', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    })
})

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')